import styled from "styled-components";
import { usePuzzelExtendedStateInformation } from "features/Header/PuzzelTelephone/provider/contexts/ListenForCallStatusContext";
import {
  IqSessionRequestType,
  Status,
} from "features/Header/PuzzelTelephone/components/types";
import { useIsTransfered } from "features/Header/PuzzelTelephone/components/CallControl/views/CallInSession/CallTransfer/TransferProvider";
import TransferredSuccessMsg from "features/Header/PuzzelTelephone/components/CallControl/views/CallInSession/CallTransfer/TransferredSuccessMsg";
import StatusConnected from "features/Header/PuzzelTelephone/components/CallControl/views/CallInSession/StatusConnected";
import StatusInService from "features/Header/PuzzelTelephone/components/CallControl/views/CallInSession/StatusInService";
import StatusSetup from "features/Header/PuzzelTelephone/components/CallControl/views/CallInSession/StatusInSetup";

const CallInSessionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  &:nth-child(1) {
    margin-left: 1rem;
  }
`;

const CallInSession = () => {
  const isTransfered = useIsTransfered();

  const { iqSessionStateRequests }: any = usePuzzelExtendedStateInformation();

  if (isTransfered) return <TransferredSuccessMsg />;

  if (iqSessionStateRequests?.length > 0) {
    return (
      <CallInSessionWrapper>
        {iqSessionStateRequests.map((req: IqSessionRequestType) => {
          // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check -- few special cases
          switch (req.status) {
            case Status.Connected:
              return <StatusConnected key={req.id} req={req} />;

            case Status.InService:
              return <StatusInService key={req.id} req={req} />;

            case Status.Setup:
              return <StatusSetup key={req.id} req={req} />;

            default:
              return null;
          }
        })}
      </CallInSessionWrapper>
    );
  }
  return null;
};

export default CallInSession;
